import type { EnglishIqMessagesType } from '../english-iq-messages-type';

interface IEnglishIqQuestionProgressProps {
  index: number;
  messages: EnglishIqMessagesType['wizard'];
  minutes: number;
  progress: number;
  skillLabel: string;
}

export function EnglishIqQuestionProgress({
  index,
  messages,
  minutes,
  progress,
  skillLabel,
}: IEnglishIqQuestionProgressProps): React.JSX.Element {
  const progressLabel = messages.progress.replace('{index}', String(index));
  const milestoneLabel = messages.nextMilestone.replace('{minutes}', String(minutes));
  return (
    <>
      <div className="mb-5 flex items-end justify-between gap-4 sm:mb-8 sm:gap-6">
        <div>
          <p className="text-sm font-semibold text-violet-600 dark:text-violet-300">{skillLabel}</p>
          <p className="mt-1 text-sm text-muted-foreground">{progressLabel}</p>
        </div>
        <p className="max-w-52 text-end text-xs text-muted-foreground">{milestoneLabel}</p>
      </div>
      <div
        aria-label={milestoneLabel}
        aria-valuemax={100}
        aria-valuemin={0}
        aria-valuenow={Math.round(Math.max(0, progress))}
        className="mb-6 h-2 overflow-hidden rounded-full bg-foreground/10 sm:mb-10"
        role="progressbar"
      >
        <div
          className="h-full rounded-full bg-gradient-to-r from-violet-600 to-cyan-500 transition-[width] duration-500 motion-reduce:transition-none"
          style={{ width: `${Math.max(8, progress)}%` }}
        />
      </div>
    </>
  );
}
